import { useEffect, useState } from 'react';
import { fetchWasteTransactions } from '../api/waste-transactions';

export function useWasteTransactions() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        fetchWasteTransactions()
            .then((result) => { if (!cancelled) setData(result); })
            .catch((err) => { if (!cancelled) setError(err); })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };
        
    }, []);

    return { data, loading, error };
}